import '../orders.css';
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite';
import Column from '../../../common/marking/column';
import api from "../../../../services/api"
import InputHSelect from '../../../elements/inpute/InputHSelect'
import InputHDate from '../../../elements/inpute/InputHDate'
import InputHRange from '../../../elements/inpute/InputHRange'
import InputH from '../../../elements/inpute/InputH';

const DeliveryType = observer(() => {

    const [ catalogTypeDelivery, setCatalogTypeDelivery ] = useState(null)
    // eslint-disable-next-line 
    const [ time, setTime ] = useState('')
    // eslint-disable-next-line
    const [ deliveryType, setDeliveryType ] = useState(null)
    const [ deliveryPrice, setDeliveryPrice ] = useState(null)
    const [ deliverySupplierPrice, setDeliverySupplierPrice ] = useState(null)

    useEffect(() => {
        const getData = async () => {
            await api.post('/orders/get-type-delivery', {})
                .then(res => setCatalogTypeDelivery(res.data))
        }
        getData()
    }, [])

    useEffect(() => {
        if (catalogTypeDelivery !== null) {
            let currentTypeDelivery = catalogTypeDelivery.filter(item => {
                return Number(item.id) === Number(deliveryType)
            })
            setDeliveryPrice(currentTypeDelivery.price)
            setDeliverySupplierPrice(111)
        }
        // eslint-disable-next-line 
    }, [deliveryType])

    return (
        <div>
             <Column contant={
                <div>
                    { catalogTypeDelivery !== null ? <InputHSelect label={'Тип доставки'} data={catalogTypeDelivery} method={setDeliveryType} /> : '' }
                    <InputHDate label={'Дата отгрузки'} method={() => {}} />
                    <InputHRange label={'Время доставки'} method={setTime} placeholderMin={'__:__'} placeholderMax={'__:__'} classInput={'delivery-input'} maskMin={{mask: '__:__', replacement: { _: /\d/ }}} maskMax={{mask: '__:__', replacement: { _: /\d/ }}} />
                    { deliveryPrice !== null ? <InputH label={'Стоимость доставки'} method={setDeliveryPrice} value={deliveryPrice}/> : "" }
                    { deliverySupplierPrice !== null ? <InputH label={'Себестоимость доставки'} method={setDeliverySupplierPrice} value={deliverySupplierPrice}/> : "" }
                </div>
             }/>
        </div>
    )
})

export default DeliveryType;